/**
 * @import { MapProps } from '@vis.gl/react-google-maps'
 */

import { useBounds } from '@/features/world-map/hooks/use-bounds';
import { MapTypeControl } from '@/ui/map-type-control/map-type-control';
import { ZoomControl } from '@/ui/zoom-control/zoom-control';
import { Map } from '@vis.gl/react-google-maps';
import { useRef } from 'react';
import { FiltersModal } from '../../../filters-modal/filters-modal';
import { Header } from '../../../header/header';
import { Legend } from '../../../legend/legend';
import { ModalProvider } from '../../../modal-provider';
import { PlacesLayer } from '../../../places-layer';
import { DesktopPanel } from '../desktop-panel';
import classes from './desktop-map.module.css';
import { BackToPreviousControl } from '../../../back-to-previous-control/back-to-previous-control';

/**
 * @param {object} props
 * @param {MapProps} props.mapProps
 */
export function DesktopMap({ mapProps }) {
  /** @type {React.Ref<HTMLDivElement | null>} */
  const modalContainerRef = useRef(null);
  useBounds();

  return (
    <ModalProvider>
      <div className={classes.desktopMap}>
        <Header />
        <div ref={modalContainerRef} style={{ position: 'relative', display: 'flex', flex: 'auto' }}>
          <Map style={{ flex: 'auto' }} {...mapProps}>
            <PlacesLayer />
             <BackToPreviousControl />
            <MapTypeControl />
            <Legend />
            <ZoomControl />
          </Map>
          <DesktopPanel />
          <FiltersModal container={modalContainerRef} />
        </div>
      </div>
    </ModalProvider>
  );
}
